import window from 'inputmask/lib/global/window';

const EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/;

function isEmailValid($email) {
  $email = $email.val();
  const isBlank = !$email;
  $email = isBlank ? '' : $email.trim();
  const matchesExpression = EMAIL_REGEXP.test($email);
  return !isBlank && matchesExpression;
}

function isEmailValidString(value) {
  const email = (value || '').trim();
  return email.length > 0 && EMAIL_REGEXP.test(email);
}

function cleverPhoneMask(e) {
  let val = $(this).val();
  if (val.length === 2) {
    if (val[0] === '7' && /^\d+$/.test(val[1])) {
      $(this).val('+7' + val[1]);
    } else if (val[0] === '8' && /^\d+$/.test(val[1])) {
      window.was8ChangedTo7 = true;
      $(this).val('7' + val[1]);
    } else if (val[0] === '9' && /^\d+$/.test(val[1])) {
      $(this).val('+7' + val[0] + val[1]);
    }
  } else if (val.length === 3) {
    if (val[0] === '7' && /^\d+$/.test(val[1]) && /^\d+$/.test(val[1])) {
      $(this).val('+7' + val[1] + val[2]);
    }
  } else if (!/^\d+$/.test(val.slice(1)) && val.length >= 1) {
    let newVal = val;
    if (val[0] === '+') newVal = val.slice(1);
    if (window.was8ChangedTo7 && newVal[0] === '7') newVal = '8' + newVal.slice(1);
    $(this).val(newVal);
    window.was8ChangedTo7 = false;
  }
}

export { cleverPhoneMask, isEmailValid, isEmailValidString };
